
function initContentWrapper(contentWrapper: HTMLDivElement) {
    const seeMoreLink = contentWrapper.querySelector('.pc_sp_see_more_link') as HTMLAnchorElement;

    if (seeMoreLink) {
        const contentP = contentWrapper.querySelector('.pc_sp_review_content');
        seeMoreLink.addEventListener('click', (event) => {
            event.preventDefault();
            console.log("GFGFGDFGDFGDFGDFGDGD", contentP);
            if (contentP) {
                contentP.classList.toggle('line-clamp-3');
                seeMoreLink.textContent = contentP.classList.contains('line-clamp-3') ? 'See Less' : 'See More';
            }
        });
    }
}

function helpfulVoteHandler(element: HTMLDivElement) {
    const helpfulButton = element.querySelector('.pc_sp_single_review_helpful_btn') as HTMLButtonElement;
    if (!helpfulButton) return;

    const temporary_toggle_button = ()=>{
        const votedImage = helpfulButton.getAttribute("data-voted-image") as string;
        const unvoteImage = helpfulButton.getAttribute("data-unvote-image") as string;
        const helpfulCountElement = helpfulButton.querySelector('span') as HTMLSpanElement;
        let count = parseInt(helpfulCountElement.textContent || '0', 10);

        // check button classList have voted
        if (helpfulButton.classList.contains('voted')) {
            helpfulButton.classList.remove('voted');
            count--;
            helpfulButton.querySelector('img')?.setAttribute('src', unvoteImage);
        } else {
            helpfulButton.querySelector('img')?.setAttribute('src', votedImage);
            count++;
            helpfulButton.classList.add('voted');   
        }
        helpfulCountElement.textContent = count.toString();
    }
    helpfulButton.addEventListener('click', () => {
        // Handle the helpful vote logic here
        const reviewID = helpfulButton.getAttribute("data-review-id") || "";
        const ajaxURL = helpfulButton.getAttribute("data-ajax-url") || "";
        const fd = new FormData();
        fd.append('action', 'pc_sp_toggle_review_helpful');
        fd.append("comment_id", reviewID);

        // render before updating
        temporary_toggle_button();
        fetch(ajaxURL, {
            method: 'POST',
            body: fd
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                if (data.data.helpful_count !== undefined) {
                    const helpfulCountElement = helpfulButton.querySelector('span') as HTMLSpanElement;
                    helpfulCountElement.textContent = data.data.helpful_count;
                } 
                if (data.data.is_user_voted) {
                    helpfulButton.classList.add('voted');
                    const votedImage = helpfulButton.getAttribute("data-voted-image");
                    if (votedImage) {
                        helpfulButton.querySelector('img')?.setAttribute('src', votedImage);
                    }
                } else {
                    helpfulButton.classList.remove('voted');
                    const unvoteImage = helpfulButton.getAttribute("data-unvote-image");
                    if (unvoteImage) {
                        helpfulButton.querySelector('img')?.setAttribute('src', unvoteImage);
                    }
                }
            } else {
                console.error("Error recording vote:", data.error);
            }
        })
        .catch(error => {
            console.error("Fetch error:", error);
        });

        console.log("Helpful vote clicked");
    });
}

function initSingleReview(element: HTMLDivElement){
    initContentWrapper(element.querySelector('.pc_sp_review_content_wrapper') as HTMLDivElement);
    helpfulVoteHandler(element);
}

export function initSingleReviewControls(){
    const reviews = document.querySelectorAll('.pc_sp_single_review');
    reviews.forEach((element) => {
        // this method will execute each time dynamic content was added. Thus this will prevent 
        // if the element is already initialized
        const isInitilized = element.hasAttribute("data-initialized");
        if (!isInitilized) {
            element.setAttribute("data-initialized", "true");
            initSingleReview(element as HTMLDivElement);
        }
    });
}